import { render, staticRenderFns } from "./CoordinatorSetting.vue?vue&type=template&id=3471acb1"
import script from "./CoordinatorSetting.vue?vue&type=script&lang=js"
export * from "./CoordinatorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports